import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { getCapabilitiesData } from '../clients/getCapabilitiesData';
import { CAPABILITIES_DATA_FETCH } from '../constants/asyncActionTypes';
export const fetchCapabilitiesData = createAsyncAction({
  requestFn: getCapabilitiesData,
  actionTypes: CAPABILITIES_DATA_FETCH,
  toRecordFn: data => data
});